import posthog from 'posthog-js'
import { IS_PROD, POSTHOG_KEY } from 'config'
import { ConsentStatus } from 'store/consent'

export const posthogEnabled = IS_PROD && !!POSTHOG_KEY

export const initPosthog = () => {
  if (!posthogEnabled) return
  posthog.init(POSTHOG_KEY, {
    api_host: 'https://eu.i.posthog.com',
    defaults: '2026-01-30',
    // Capturing never stops, it degrades: on rejection PostHog keeps sending events without
    // cookies or a persistent id, instead of going silent.
    cookieless_mode: 'on_reject',
    capture_exceptions: true,
    capture_heatmaps: true,
    session_recording: { maskAllInputs: true, sampleRate: 1.0 },
  })
}

export const capturePosthog = (event: string, properties?: Record<string, unknown>) => {
  if (!posthogEnabled) return
  posthog.capture(event, properties)
}

export const syncPosthogConsent = (status: ConsentStatus) => {
  if (!posthogEnabled) return
  if (status === 'granted') posthog.opt_in_capturing()
  else if (status === 'denied') posthog.opt_out_capturing()
  else posthog.clear_opt_in_out_capturing()
}
